<template>
  <div :class="['row-checkbox', cssClass]" @click="$emit('trackClick', value, id)">
    <span>
      <CheckboxGeneral :id="id" :checked="isSelected" @toggle="onToggle" />
      <label :for="id" class="row-checkbox__label">
        <h3 v-if="isHeading" style="color: rgba(255, 255, 255, 0.95)">
          {{ value }}
        </h3>
        <h4 v-else :class="cssClass">
          {{ value }}
        </h4>
      </label>
    </span>
    <img v-if="imageSource" :src="imageSource" class="row-checkbox__icon" />
    <div v-if="circleColor" class="circle" :style="{ backgroundColor: circleColor }" />
  </div>
</template>

<script>
import CheckboxGeneral from '@/components/general/selectors/CheckboxGeneral.vue'
export default {
  name: 'DropdownRowCheckbox',
  components: {
    CheckboxGeneral
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    circleColor: {
      type: String,
      default: ''
    },
    id: {
      type: [Number, String],
      required: true
    },
    imageSource: {
      type: String,
      default: ''
    },
    isHeading: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    cssClass: {
      type: String,
      validator: (prop) => {
        return ['dark', 'light', 'color', 'none'].includes(prop)
      },
      default: 'none'
    }
  },
  emits: ['isChecked', 'trackClick'],
  data() {
    return {
      checked: false
    }
  },
  watch: {
    checked(isChecked) {
      this.$emit('isChecked', isChecked, this.id, this.value)
    }
  },
  created() {
    this.checked = this.isSelected
  },
  methods: {
    onToggle(value) {
      this.$emit('isChecked', value, this.id, this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';
.circle {
  border: solid 2px $color-grey-lighter;
  border-radius: 50%;
  height: 18px;
  min-width: 18px;
  width: 18px;
}
.row-checkbox {
  margin: $margin-small;
  display: flex;
  height: $size-dropdown-row-checkbox-small;
  justify-content: space-between;
  align-items: center;
  &.color {
    background-color: $color-primary;
    &:hover {
      background-color: $color-primary-dark;
    }
  }
  &.light {
    background-color: $color-grey-light;
    color: $color-grey-darker;
    margin: 0;
    padding: 20px $margin-drop-down-filter;
    &:hover {
      background-color: $color-grey;
    }
  }
  &.dark {
    &:hover {
      background-color: $color-grey-blue-darker;
    }
  }
  span {
    align-items: center;
    display: flex;
  }
  &__checkbox {
    margin-bottom: 0;
    margin-right: $margin-small;
    margin-top: 0;
    vertical-align: middle;
  }
  &__label {
    vertical-align: middle;
    margin-left: 10px;
  }
  &__icon {
    max-height: $size-overview-button-small;
  }
}

.none {
  color: white;
}
</style>
